// This module provides API call methods for Sephora Commerce
// Search & Browse APIs:
// https://jira.sephora.com/wiki/pages/viewpage.action?pageId=120041949

const getProductDetails = require('services/api/search-n-browse/getProductDetails');
const getSkuDetails = require('services/api/search-n-browse/getSkuDetails');
const findInStore = require('services/api/search-n-browse/findInStore');
const { searchProductsByKeyword, getProductsFromKeyword } = require('services/api/search-n-browse/searchProductsByKeyword');
const searchTypeAhead = require('services/api/search-n-browse/searchTypeAhead');
const getCategories = require('services/api/search-n-browse/getCategories');
const getSpecialSearchTermComponents = require('services/api/search-n-browse/getSpecialSearchTermComponents');
const { getNthLevelCategory, getCategory } = require('services/api/search-n-browse/getNthLevelCategory');
const { getNthLevelBrand, getBrand } = require('services/api/search-n-browse/getNthLevelBrand');

module.exports = {
    getProductDetails,
    getSkuDetails,
    findInStore,
    searchProductsByKeyword,
    getProductsFromKeyword,
    searchTypeAhead,
    getNthLevelCategory,
    getCategory,
    getCategories,
    getNthLevelBrand,
    getBrand,
    getSpecialSearchTermComponents
};
